import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_parking_lines`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}




function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_parking_lines/${id}`, options)
    .then(response => {
      let parking_line = jsona.deserialize(response.data);
      delete parking_line.links;
      return parking_line;
    });
}

function add(parking_line) {
  
  console.log(parking_line);
  const payload = jsona.serialize({
    stuff: parking_line,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_parking_lines`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(parking_line) {
  const payload = jsona.serialize({
    stuff: parking_line,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_parking_lines/${parking_line.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_parking_lines/${id}`, options);
}

function quota (status) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_parking_lines?filter[category_full]=${status}`, options)
  .then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}


export default {
  list,
  get,
  add,
  update,
  destroy,
  quota
};

